// Helpers for working with barcodes inside the POS — both generating new
// internal-use EAN-13 codes and rendering them with jsbarcode.

import JsBarcode from 'jsbarcode';

// EAN-13 check digit. Takes the first 12 digits, returns 0–9.
export const ean13Checksum = (digits12) => {
  if (!/^\d{12}$/.test(String(digits12))) return null;
  let sum = 0;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(digits12[i], 10) * (i % 2 === 0 ? 1 : 3);
  }
  return (10 - (sum % 10)) % 10;
};

// Generate a fresh internal-use EAN-13. The "200" prefix is reserved for
// in-store / private codes per GS1, so retailers can mint their own without
// stepping on a real registered product.
export const generateEAN13 = () => {
  const prefix = '200';
  let body = '';
  for (let i = 0; i < 9; i++) body += Math.floor(Math.random() * 10);
  const base = prefix + body;
  return base + ean13Checksum(base);
};

// Format auto-detected from the data. EAN-13 if all-digits-13, EAN-8 if
// all-digits-8, otherwise CODE128 (safe default for any alphanumeric).
const guessFormat = (data) => {
  const s = String(data).trim();
  if (/^\d{13}$/.test(s)) return 'EAN13';
  if (/^\d{8}$/.test(s))  return 'EAN8';
  if (/^\d{12}$/.test(s)) return 'UPC';
  return 'CODE128';
};

// Render a barcode into a given <svg> element (the caller controls sizing).
// Throws nothing — invalid input just clears the SVG.
export const renderBarcode = (svgEl, data, opts = {}) => {
  if (!svgEl) return;
  const text = String(data || '').trim();
  while (svgEl.firstChild) svgEl.removeChild(svgEl.firstChild);
  if (!text) return;
  try {
    JsBarcode(svgEl, text, {
      format: opts.format || guessFormat(text),
      lineColor: opts.lineColor || '#0f172a',
      background: opts.background || '#ffffff',
      width: opts.width || 2,
      height: opts.height || 60,
      displayValue: opts.displayValue !== false,
      fontOptions: 'bold',
      font: 'Inter, -apple-system, sans-serif',
      fontSize: opts.fontSize || 14,
      margin: opts.margin ?? 4,
      textMargin: 2,
    });
  } catch (_) {
    // Bad input — leave the svg empty so the caller can show their own hint.
  }
};
